<template>
  <edit-booking />
</template>

<script>
import EditBooking from "@/components/3pl/Operations/Bookings/EditBooking/Index";
export default {
  components: {
    EditBooking,
  },
};
</script>

<style></style>
